module.exports = __webpack_public_path__ + "media/images/area-badges/clean-transport-f8246adfa13ae2214e53a9d499c52a3b.svg";